import { model as session } from '$/session'
import { aye } from '@/helpers'
import { api, type OVPProfile } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'

export const init = createEvent()

export const getProfileFx = attach({ effect: api.profile.getProfileFx })

// Get profile after launch to update primaryRegion
sample({
  clock: session.$isAuthenticated,
  filter: aye,
  target: getProfileFx,
})

export const setProfileFx = attach({ effect: api.profile.setProfileFx })

export const $profile = createStore<OVPProfile | null>(null) //
  .reset(
    getProfileFx.fail,
    api.user.logOutFx.done,
    api.events.http.unauthorized
  )
  .on(getProfileFx.doneData, (_, profile) => profile)

// refresh username in navbar
sample({
  clock: setProfileFx.done,
  target: [getProfileFx, api.userSession.getInfoFx],
})
